import React from "react";
import { Link } from "react-router-dom";
import { specialThemes } from "../utils";
import ThemeCard from "./ThemeCard";

/**
 * @param {number} [size]
 * @returns {JSX.Element}
 */
function ChevronIcon({ size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
    >
      <path d="M9 6l6 6-6 6" />
    </svg>
  );
}

/**
 * Beta palettes nested under Appearance.
 * @param {Object} props
 * @param {string} props.theme
 * @param {function(string): void} props.setTheme
 * @param {function(Object): void} props.onUpdateSettings
 * @returns {JSX.Element}
 */
function SpecialThemesTab({ theme, setTheme, onUpdateSettings }) {
  return (
    <div className="space-y-6">
      <div>
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-2 text-sm">
          <Link
            to="/settings/appearance"
            className="font-medium text-accent underline underline-offset-2 hover:text-text-accent-hover"
          >
            Appearance
          </Link>
          <span className="text-text-muted" aria-hidden>
            <ChevronIcon />
          </span>
          <span className="text-text-secondary" aria-current="page">
            Special themes (beta)
          </span>
        </nav>
        <h2 className="mt-3 text-2xl font-bold text-text-primary">Special themes</h2>
        <p className="mt-1 text-sm text-text-secondary sm:text-base">
          Experimental palettes. They may change.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
        {specialThemes.map((themeOption) => (
          <ThemeCard
            key={themeOption.id}
            themeId={themeOption.id}
            label={themeOption.label}
            currentTheme={theme}
            setTheme={setTheme}
            onUpdateSettings={onUpdateSettings}
          />
        ))}
      </div>
    </div>
  );
}

export default SpecialThemesTab;
